<template>
  <div>
    <v-container>
      <v-row>
        <v-col md="12" class="text-center">
          <h1>{{ $t("startGrids.title") }}</h1>
        </v-col>
        <v-col md="8" offset-md="2">
          <template>
            <v-row>
              <v-col md="8">
                <v-select
                  outlined
                  :label="$t('startGrids.select_race')"
                  :items="racesStartGrid"
                  v-model="racesStartSelect"
                  item-value="id"
                  item-text="name"
                  @change="openStartGrid"
                  return-object
                  :no-data-text="$t('common.no_data')"
                ></v-select>
              </v-col>
              <v-col md="4">
                <v-btn
                  color="primary"
                  class="btn"
                  type="button"
                  @click="startGridsProcess"
                  >{{ $t("startGrids.add_start_button") }}</v-btn
                >
              </v-col>
            </v-row>
            <v-dialog v-model="startGridDialog" width="600">
              <v-container>
                <v-card>
                  <v-card-title>
                    <span class="headLine">{{ startGridTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="formStartGrids">
                      <v-row>
                        <v-col md="12">
                          <v-text-field
                            v-model="startGridName"
                            outlined
                            :label="$t('startGrids.start_grid_name')"
                            :rules="[ v => !!v || $t('startGrids.start_grid_name_required') ]"
                          ></v-text-field>
                        </v-col>
                        <v-col md="12">
                          <v-select
                            outlined
                            :label="$t('startGrids.select_race')"
                            :items="races"
                            item-value="id"
                            item-text="raceName"
                            v-model="raceSelect"
                            :rules="[ v => !!v || $t('startGrids.race_required') ]"
                            :disabled="editStartGrid"
                            :no-data-text="$t('common.no_data')"
                          >
                            <template v-slot:item="{ item, attrs, on }">
                                <v-list-item v-on="on" v-bind="attrs">
                                  <v-list-item-content>
                                      <v-list-item-title>
                                          <span v-html="item.raceName"></span>
                                      </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                            </template>
                            <template v-slot:selection="{ item }">
                              <span v-html="item.raceName"></span>
                            </template>
                          </v-select>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-row>
                      <v-col class="text-right">
                        <v-btn color="darken-1" dark small class="mr-4" @click="startGridDialog = false">{{
                          $t("startGrids.button_cancel")
                        }}</v-btn>
                        <v-btn color="darken-1" dark small v-if="!editStartGrid" @click="createStartGrid">
                          {{ $t("startGrids.button_asave_and_closedd") }}
                        </v-btn>
                        <v-btn color="darken-1" dark small v-else @click="editStartGridSave">
                          {{ $t("common.save_and_close") }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-dialog>
          </template>
        </v-col>
      </v-row>
      <v-row v-if="showCardGrid">
        <v-col md="12">
          <v-card>
            <v-card-title>
              <v-row>
                <v-col md="6" class="text-left">
                  {{ startGridNameTitle }}
                  <v-icon class="ml-4" @click="openEdit">mdi-pencil</v-icon>
                </v-col>
                <v-col md="6" class="text-right">
                  <v-btn color="secundary" @click="print">{{
                    $t("startGrids.button_printall")
                  }}</v-btn>
                  <v-btn color="secundary" class="mx-2" @click="download">{{
                    $t("startGrids.button_westhold")
                  }}</v-btn>
                  <v-btn color="secundary" @click="deleteSG">{{
                    $t("startGrids.button_delete")
                  }}</v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-expansion-panels accordion>
                <v-expansion-panel key="configS">
                  <v-expansion-panel-header>{{ $t("startGrids.tab_configuration_title") }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col md="12" class="text-right">
                        <v-btn class="my-2" @click="generateStartGrid">
                          {{ $t("startGrids.generate_start_grid_btn") }}
                        </v-btn>
                      </v-col>
                      <v-col md="12" class="text-right">
                        <v-checkbox
                          :label="$t('startGrids.check_make_start')"
                          v-model="onLine"
                          @change="updateOnLine($event)"
                        ></v-checkbox>
                      </v-col>
                      <v-col md="12">
                        <v-data-table
                          key="racesTable"
                          :headers="headersRace"
                          :items="itemsRace"
                          item-key="index"
                          :footer-props="{
                            'items-per-page-text': $t('dataTable.rowsPerPageText'),
                            'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                          }"
                          :no-data-text="$t('dataTable.noDataText')"
                          :headerProps="{
                            'sort-by-text': $t('dataTable.sortByText')
                          }"
                        >
                          <template v-slot:item.raceName="{ item }">
                            <span v-html="item.raceName"></span>
                          </template>
                        </v-data-table>
                      </v-col>
                      <v-col md="12">
                        <!-- Modal add Class -->
                        <template>
                          <v-row>
                            <v-col md="12" class="text-left my-2">
                              <v-btn
                                color="primary"
                                type="button"
                                class="mr-2"
                                @click="addClassProccess('single')"
                              >
                                  {{ $t("startGrids.add_classes_btn") }}
                              </v-btn>
                              <v-btn
                                color="primary"
                                type="button"
                                @click="addClassProccess('all')"
                              >
                                  {{ $t("startGrids.add_classes_all_btn") }}
                              </v-btn>
                            </v-col>
                          </v-row>

                          <v-dialog v-model="addClassModal" width="600">
                              <v-card>
                                <v-form ref="formAddClass">
                                  <v-card-title>
                                    <span class="headLine">{{ $t("startGrids.add_classes_btn") }}</span>
                                  </v-card-title>
                                  <v-card-text>
                                    <v-row>
                                      <v-col md="12" class="text-left" v-if="allC">
                                        <p>{{ $t("startGrids.all_clases_will") }}</p>
                                      </v-col>
                                      <v-col md="12" class="text-left" v-if="!allC">
                                        <p>{{ $t("startGrids.select_classes") }}</p>
                                        <p>{{ $t("startGrids.selecting_more") }}</p>
                                      </v-col>
                                      <v-col md="12" v-if="!allC">
                                        <v-data-table
                                          key="classesSGTable"
                                          v-model="selectedClassesStartGrids"
                                          :headers="headersMiniClass"
                                          :items="itemsClass"
                                          show-select
                                          :footer-props="{
                                            'items-per-page-text': $t('dataTable.rowsPerPageText'),
                                            'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                                          }"
                                          :no-data-text="$t('dataTable.noDataText')"
                                          :headerProps="{
                                            'sort-by-text': $t('dataTable.sortByText')
                                          }"
                                        ></v-data-table>
                                      </v-col>
                                      <v-col md="12">
                                        <v-card>
                                          <v-card-title>{{ $t("startGrids.class_maximum") }}</v-card-title>
                                          <v-card-text>
                                            <v-row>
                                              <v-col md="6">
                                                <v-text-field 
                                                  v-model="maxPerRow"
                                                  outlined :label="$t('startGrids.max_per_row')"
                                                  :rules="[(v) => (v || '').length > 0 || $t('startGrids.max_per_row_required')]"
                                                ></v-text-field>
                                              </v-col>
                                              <v-col md="6">
                                                <v-text-field
                                                  v-model="maxPerClass"
                                                  outlined :label="$t('startGrids.max_per_class')"
                                                  :rules="[(v) => (v || '').length > 0 || $t('startGrids.max_per_class_required')]"
                                                ></v-text-field>
                                              </v-col>
                                            </v-row>
                                            <v-row>
                                              <v-col md="12" class="text-left">{{ $t("startGrids.when_the_maximum") }}</v-col>
                                            </v-row>
                                          </v-card-text>
                                        </v-card>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-row>
                                      <v-col class="text-right">
                                        <v-btn color="darken-1" dark small class="mr-4" @click="addClassModal = false">
                                          {{ $t("startGrids.button_cancel") }}
                                        </v-btn>
                                        <v-btn color="darken-1" dark small @click="saveClass">
                                          {{ $t("common.save_and_close") }}
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-card-actions>
                                </v-form>
                              </v-card>
                          </v-dialog>
                        </template>
                        <v-data-table
                          key="classTable"
                          :headers="headersClass"
                          :items="itemsClassStartGrids"
                          :footer-props="{
                            'items-per-page-text': $t('dataTable.rowsPerPageText'),
                            'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                          }"
                          :no-data-text="$t('dataTable.noDataText')"
                          :headerProps="{
                            'sort-by-text': $t('dataTable.sortByText')
                          }"
                        >
                          <template v-slot:item.actions="{ item }">
                            <v-icon small @click="confirmDelete(item)">mdi-delete</v-icon>
                          </template>
                        </v-data-table>
                      </v-col>
                      <v-col md="12">
                        <v-card>
                          <v-card-title>
                            {{ $t("startGrids.grid_position_rules") }}
                          </v-card-title>
                          <v-card-text>
                            <v-radio-group v-model="radioStartGridType" @change="updateStartGridType">
                              <v-radio :label="$t('startGrids.grid_position_rule_1')" value="Random"></v-radio>
                              <v-radio :label="$t('startGrids.grid_position_rule_2')" value="SeriesPosition"></v-radio>
                              <v-row v-if="radioStartGridType == 'SeriesPosition'">
                                <v-col  cols="12">
                                  <v-row>
                                    <v-col cols="12" md="3" sm="6">
                                      <v-select
                                        outlined
                                        :label="$t('startGrids.select_series')"
                                        :items="series"
                                        v-model="seriesSelected"
                                        item-value="id"
                                        item-text="seriesName"
                                        @change="insertSeries"
                                        :no-data-text="$t('common.no_data')"
                                      ></v-select>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                              <v-radio :label="$t('startGrids.grid_position_rule_3')" value="RacePosition"></v-radio>
                              <v-row v-if="radioStartGridType == 'RacePosition'">
                                <v-col  cols="12">
                                  <v-row>
                                    <v-col cols="12" class="my-2">
                                      <v-btn color="primary" type="button" class="mr-2" @click="addRaces">
                                        {{ $t("startGrids.add_race_btn") }}
                                      </v-btn>
                                      <p class="caption">{{ $t('startGrids.note_add_race') }}</p>
                                    </v-col>
                                    <v-dialog v-model="addRacesModal" width="600">
                                      <v-card>
                                        <v-form ref="formAddRace">
                                          <v-card-title>
                                            <span class="headLine">{{ racesStartGridTitle }}</span>
                                          </v-card-title>
                                          <v-card-text>
                                            <v-row>
                                              <v-col cols="12">
                                                <v-select 
                                                  :label="$t('startGrids.select_race')"
                                                  outlined
                                                  :items="racesItems"
                                                  item-value="id"
                                                  item-text="raceName"
                                                  v-model="racesSelect"
                                                  :rules="[ (v) => (v || '').toString().length > 0 || $t('startGrids.race_required')]"
                                                  @change="loadNParticipants"
                                                  :no-data-text="$t('common.no_data')"
                                                >
                                                  <template v-slot:item="{ item, attrs, on }">
                                                      <v-list-item v-on="on" v-bind="attrs">
                                                        <v-list-item-content>
                                                            <v-list-item-title>
                                                                <span v-html="item.raceName"></span>
                                                            </v-list-item-title>
                                                        </v-list-item-content>
                                                      </v-list-item>
                                                  </template>
                                                  <template v-slot:selection="{ item }">
                                                    <span v-html="item.raceName"></span>
                                                  </template>
                                                </v-select>
                                              </v-col>
                                              <v-col cols="12">
                                                <v-select 
                                                  :label="$t('startGrids.from_position')"
                                                  outlined
                                                  :items="fromPositionItems"
                                                  item-value="id"
                                                  item-text="raceName"
                                                  v-model="fromPositionSelect"
                                                  :rules="[ (v) => (v || '').toString().length > 0 || $t('startGrids.from_position_required')]"
                                                  :no-data-text="$t('common.no_data')"
                                                ></v-select>
                                                <div class="caption text-left">{{ $t('startGrids.from_position_note') }}</div>
                                              </v-col>
                                              <v-col cols="12">
                                                <v-select 
                                                  :label="$t('startGrids.how_many')"
                                                  outlined
                                                  :items="howManyItems"
                                                  item-value="id"
                                                  item-text="raceName"
                                                  v-model="howManySelect"
                                                  :rules="[ (v) => (v || '').toString().length > 0 || $t('startGrids.how_many_required')]"
                                                  :no-data-text="$t('common.no_data')"
                                                ></v-select>
                                                <div class="caption text-left">{{ $t('startGrids.how_many_note') }}</div>
                                              </v-col>
                                              <v-col cols="12">
                                                <v-select 
                                                  :label="$t('startGrids.start_position')"
                                                  outlined
                                                  :items="startPositionItems"
                                                  item-value="id"
                                                  item-text="raceName"
                                                  v-model="startPositionSelect"
                                                  :rules="[ (v) => (v || '').toString().length > 0 || $t('startGrids.start_position_required')]"
                                                  :no-data-text="$t('common.no_data')"
                                                ></v-select>
                                                <div class="caption text-left">{{ $t('startGrids.start_position_note') }}</div>
                                              </v-col>
                                            </v-row>
                                          </v-card-text>
                                          <v-card-actions>
                                            <v-row>
                                              <v-col class="text-right">
                                                <v-btn color="darken-1" dark small class="mr-4" @click="addRacesModal = false">
                                                  {{ $t("startGrids.button_cancel") }}
                                                </v-btn>
                                                <v-btn color="darken-1" dark small @click="saveRace">
                                                  {{ $t("common.save_and_close") }}
                                                </v-btn>
                                              </v-col>
                                            </v-row>
                                          </v-card-actions>
                                        </v-form>
                                      </v-card>
                                  </v-dialog>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12">
                                      <v-data-table
                                        :headers="headerRacesSG"
                                        :items="itemsRacesSG"
                                        item-key="index"
                                        :footer-props="{
                                          'items-per-page-text': $t('dataTable.rowsPerPageText'),
                                          'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                                        }"
                                        :no-data-text="$t('dataTable.noDataText')"
                                        :headerProps="{
                                          'sort-by-text': $t('dataTable.sortByText')
                                        }"
                                      >
                                        <template v-slot:[`item.actions`]="{ item }">
                                            <v-icon small class="mr-2" @click="editItemRaceSG(item)">mdi-pencil</v-icon>
                                            <v-icon small @click="confirmDeleteRaceSG(item)">mdi-delete</v-icon>
                                        </template>
                                      </v-data-table>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-radio-group>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col md="12" class="text-right">
                        <v-btn @click="generateStartGrid">
                          {{ $t("startGrids.generate_start_grid_btn") }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel key="startG">
                  <v-expansion-panel-header>{{ $t("startGrids.tab_start_grid") }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card v-for="(item,j) in itemsAccordeonRaces" :key="item.id" class="my-2">
                      <v-card-title v-html="item.raceName"></v-card-title>
                      <v-card-text>
                        <v-expansion-panels accordion>
                          <v-expansion-panel v-for="(subItem,i) in item.getAccordionClasses" :key="`class-${i}`">
                            <v-expansion-panel-header>{{ subItem.name }}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ClassTableVue 
                                :item="subItem" :participants="itemsParticipants" :key="`classTable-${i}-${j}`" :index="j" :subIndex="i" 
                                :classIdArray="subItem.classIdArray" :configId="item.id" :raceId="item.raceId" @showError="showError"
                                :bandReopen="dialogAlert" @confirmDeleteForClass="confirmDeleteForClass" :ref="`classTable-${i}-${j}`"
                                :refName="`classTable-${i}-${j}`" @closeDelete="closeDialogDelete"
                              />
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <SGSNotificationAlert v-if="dialogAlert" :notificationMessage="alertMessage" @cancel="closeAlert" type='error'/>
    <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('common.confirm-delete')" 
        @cancel="dialogNotification=false;" @agree="deleteItem" type='warning' :acept="$t('common.form.delete')" :reject="$t('common.form.cancel')"/>
    <SGSNotificationConfirm v-if="dialogNotificationRSG" :notificationMessage="$t('common.confirm-delete')" 
        @cancel="dialogNotificationRSG=false;" @agree="deleteItemRSG" type='warning' :acept="$t('common.form.delete')" :reject="$t('common.form.cancel')"/>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import ClassTableVue from "@/components/startGrids/ClassTable.vue";

export default {
  mixins: [apiCalls],
  components: { SGSNotificationAlert, SGSNotificationConfirm, ClassTableVue },
  name: "StartGrids",
  data() {
    return {
      startGridDialog: false,
      startGridName: "",
      showCardGrid: false,
      addClassModal: false,
      itemsClass: [],
      allC: false,
      itemsParticipants: [],
      races: [],
      raceSelect: null,
      itemsRace: [],
      racesStartGrid: [],
      racesStartSelect: null,
      itemsClassStartGrids: [],
      selectedClassesStartGrids: [],
      maxPerRow: [],
      maxPerClass: [],
      dialogAlert: false,
      reopenEdition: false,
      alertMessage: '',
      onLine: false,
      dialogNotification: false,
      item: null,
      radioStartGridType: "Random",
      series: [],
      seriesSelected: null,
      itemsRacesSG: [],
      addRacesModal: false,
      racesItems: [],
      racesSelect: null,
      fromPositionItems: [],
      fromPositionSelect: null,
      howManyItems: [],
      howManySelect: null,
      startPositionItems: [],
      startPositionSelect: null,
      editItemRacesSG: false,
      itemRaceSG: null, 
      dialogNotificationRSG: false,
      editStartGrid: false,
      itemsAccordeonRaces: [],
      refName: ''
    };
  },
  methods: {
    startGridsProcess() {
      if(this.$refs.formStartGrids) this.$refs.formStartGrids.reset();
      this.startGridDialog = true;
    },
    async createStartGrid() {
      if(this.$refs.formStartGrids.validate()) {
        let data = {
          eventId: this.$route.params.id,
          startGridName: this.startGridName,
          raceId: this.raceSelect
        };
        
        const response = await this.postApi('/api/v1/promoter/startGrid', data);
        
        if(response.success) {
          this.startGridDialog = false;
          this.showCardGrid = true;
          this.loadStartGrids(response.message);
        }
      }
      //View card delete
    },
    addClassProccess(type) {
      if (type == "single") this.allC = false;
      else this.allC = true;
      this.addClassModal = true;
      if(this.$refs.formAddClass) {
        this.$refs.formAddClass.resetValidation();
        this.maxPerRow = null;
        this.maxPerClass = null;
        this.selectedClassesStartGrids = [];
      }
    },
    async loadRaces() {
      const response = await this.getApi(`/api/v1/promoter/event/${this.$route.params.id}/races`);
      if(Array.isArray(response)) {
        this.races = response;
      }
    },
    async loadStartGrids(startGridId = 0, onlyOnLine = false) {
      const response = await this.getApi(`/api/v1/promoter/startGrid/${this.$route.params.id}`);
      
      if(response.success && Array.isArray(response.message)) {
        this.racesStartGrid = response.message;
        if(startGridId > 0) {
          this.racesStartSelect = this.racesStartGrid.find((el) => el.id == startGridId);
          if(this.racesStartSelect) {
            if(onlyOnLine) {
              this.onLine = this.racesStartSelect.isOnline;
              this.radioStartGridType = this.racesStartSelect.startGridAttributionType;
            } else {
              this.loadStartGridSelected();
            }
          }
        }
      }
    },
    openStartGrid() {
      this.showCardGrid = true;
      this.loadStartGridSelected();
    },
    async loadStartGridSelected() {
      if(this.racesStartSelect) {
        this.onLine = this.racesStartSelect.isOnline;
        this.radioStartGridType = this.racesStartSelect.startGridAttributionType;
        const response = await this.getApi(`/api/v1/promoter/startGrid/getData/${this.$route.params.id}/${this.racesStartSelect.id}`);
        
        if(response.success) {
          this.itemsRace = (response.message.startGridsRaces || []).map((el,i) => { return {...el, index: i} });
          this.itemsClass = response.message.classRace;
          this.itemsClassStartGrids = [];
          
          response.message.registeredStartGrid.forEach((item) => {
            const find = this.itemsClassStartGrids.findIndex((item1) => { 
              return item.raceStartGridClassConfigId == item1.raceStartGridClassConfigId 
            });

            if(find < 0) {
              this.itemsClassStartGrids.push({ ...item, className: item.name });
            } else {
              this.itemsClassStartGrids[find].className += `, ${item.name}`;
              this.itemsClassStartGrids[find].totalParticipants += item.totalParticipants;
            }
          });
          this.series = response.message.seriesByUser;
          this.seriesSelected = response.message.series ? response.message.series.fkSeriesId : null;
          this.racesItems = response.message.races;
          this.itemsRacesSG = response.message.listRaceStartGrid.map((el,i) => { return { ...el, index: i } });
          this.itemsAccordeonRaces = response.message.accordionRaces;
          this.itemsParticipants = response.message.participants;
        }
      }
    },
    async saveClass() {
      if(!this.allC) {
        if(this.$refs.formAddClass.validate() && this.selectedClassesStartGrids.length > 0) {
          let data = {
            startGridId: this.racesStartSelect.fkRaceStartGridConfigId,
            maxPerRow: this.maxPerRow,
            maxPerClass: this.maxPerClass,
            classesRacesId: this.selectedClassesStartGrids.map((el) => el.id )
          };
          
          const response = await this.postApi('/api/v1/promoter/startGrid/createStartGridClassConfig', data);
          
          if(response.success) {
            this.addClassModal = false;
            this.loadStartGridSelected();
          } else {
            this.dialogAlert = true;
            this.alertMessage = this.$t('startGrids.save_failure');
          }
        } else {
          if(!this.selectedClassesStartGrids || this.selectedClassesStartGrids.length == 0) {
            this.dialogAlert = true;
            this.reopenEdition = true;
            this.alertMessage = this.$t('startGrids.classes_required');
          }
        }
      } else {
        if(this.$refs.formAddClass.validate()) {
          let data = {
            configId: this.racesStartSelect.fkRaceStartGridConfigId,
            maxRow: this.maxPerRow,
            maxClass: this.maxPerClass,
            raceId: this.racesStartSelect.raceId
          };
          
          const response = await this.postApi('/api/v1/promoter/startGrid/allClasses', data);
          
          if(response.success) {
            this.addClassModal = false;
            this.loadStartGridSelected();
          } else {
            this.dialogAlert = true;
            this.alertMessage = this.$t('startGrids.save_failure');
          }
        }
      }
    },
    closeAlert(){
      this.dialogAlert=false;
      if(this.reopenEdition){
          this.addClassModal = true;
      }
    },
    showError({ message }) {
      this.dialogAlert = true;
      this.alertMessage = message;
    },
    confirmDelete(item) {
      this.dialogNotification = true
      this.item = item
    },
    async updateOnLine(newValue) {
      if(this.racesStartSelect) {
        let data = {
          id: this.racesStartSelect.id,
          onLine: newValue
        };
        const response = await this.postApi('/api/v1/promoter/startGrid/updateOnLine', data);
        
        if(!response || !response.success) {
          this.dialogAlert = true;
          this.alertMessage = this.$t('startGrids.save_failure');
        }
        
        this.loadStartGrids(this.racesStartSelect.id, true);
      }
    },
    async deleteItem() {
      if(this.bandForClass) {
        if(this.$refs[this.refName] && this.$refs[this.refName].length > 0) {
          this.$refs[this.refName][0].deleteItem();
        }

      } else if(this.item) {
        let data = {
          id: this.item.raceStartGridClassConfigId
        };
        const response = await this.deleteApi('/api/v1/promoter/startGrid/deleteClass', data);
        
        if(!response || !response.success) {
          this.dialogNotification = false;
          this.dialogAlert = true;
          this.alertMessage = this.$t('startGrids.save_failure');
        }

        this.dialogNotification = false;
        this.loadStartGridSelected();
      }
    },
    async updateStartGridType() {
      if(this.racesStartSelect) {
        let data = {
          startGridId: this.racesStartSelect.id,
          startGridOption: this.radioStartGridType
        };

        const response = await this.postApi('/api/v1/promoter/startGrid/updateStartGridAttibutionType', data);
        
        if(!response || !response.success) {
          this.dialogAlert = true;
          this.alertMessage = this.$t('startGrids.save_failure');
        }
      }
    },
    async insertSeries(newValue) {
      if(this.racesStartSelect) {
        let data = {
          startGridId: this.racesStartSelect.id,
          seriesId: newValue
        };

        const response = await this.postApi('/api/v1/promoter/startGrid/insertSeries', data);

        if(!response || !response.success) {
          this.dialogAlert = true;
          this.alertMessage = this.$t('startGrids.save_failure');
        }
      }
    },
    addRaces() {
      this.addRacesModal = true;
      if(this.$refs.formAddRace) this.$refs.formAddRace.reset();
    },
    async saveRace() {
      if(this.racesStartSelect) {
        if(this.$refs.formAddRace.validate()) {
          if(!this.editItemRacesSG) {
            let data = {
              raceId: this.racesSelect,
              configId: this.racesStartSelect.id,
              topPositions: this.howManySelect,
              fromPosition: this.fromPositionSelect,
              startPositions: this.startPositionSelect
            };

            const response = await this.postApi('/api/v1/promoter/startGrid/insertRace', data);
            
            if(response.success) {
              this.addRacesModal = false;
              this.loadStartGridSelected();
            } else {
              this.dialogAlert = true;
              this.alertMessage = this.$t('startGrids.save_failure');
            }
          } else {
            let data = {
              id: this.itemRaceSG.raceGridRaceId,
              topPositions: this.howManySelect,
              fromPosition: this.fromPositionSelect,
              startPositions: this.startPositionSelect
            };

            const response = await this.putApi('/api/v1/promoter/startGrid/updateRaces', data);
            
            if(response.success) {
              this.addRacesModal = false;
              this.loadStartGridSelected();
            } else {
              this.dialogAlert = true;
              this.alertMessage = this.$t('startGrids.save_failure');
            }
          }
        }
      }
    },
    async loadNParticipants(newValue) {
      if(newValue) {
        const response = await this.getApi(`/api/v1/promoter/startGrid/getNParticipants/${newValue}`);

        if(response.success) {
          const n = response.message.n;
          let items = [];
          for(let i = 1; i <= n; i++) {
            items.push(i);
          }
          this.fromPositionItems = items;
          this.howManyItems = items;
          this.startPositionItems = items;
        }
      }
    },
    async editItemRaceSG(item) {
      this.editItemRacesSG = true;
      this.itemRaceSG = item;
      this.addRacesModal = true;
      this.racesSelect = item.id;
      await this.loadNParticipants(this.racesSelect);
      this.howManySelect = item.topPosition;
      this.startPositionSelect = item.StartPosition;
      this.fromPositionSelect = item.fromPosition;
    },
    confirmDeleteRaceSG(item) {
      this.dialogNotificationRSG = true
      this.itemRaceSG = item
    },
    async deleteItemRSG() {
      if(this.itemRaceSG) {
        const response = await this.deleteApi(`/api/v1/promoter/startGrid/deleteRace/${this.itemRaceSG.raceGridRaceId}`);
        
        if(!response || !response.success) {
          this.dialogNotificationRSG = false;
          this.dialogAlert = true;
          this.alertMessage = this.$t('startGrids.save_failure');
        }

        this.dialogNotificationRSG = false;
        this.loadStartGridSelected();
      }
    },
    openEdit() {
      if(this.$refs.formStartGrids) this.$refs.formStartGrids.resetValidation();
      this.startGridDialog = true;
      if(this.racesStartSelect) {
        this.startGridName = this.racesStartSelect.name;
        this.raceSelect = this.racesStartSelect.raceId;
      }
      this.editStartGrid = true;
    },
    async editStartGridSave() {
      let data = {
        startGridId: this.racesStartSelect.id,
        field: 'name',
        value: this.startGridName
      };
      const response = await this.postApi('/api/v1/promoter/startGrid/updateStartGrid', data);
      
      if(!response || !response.success) {
          this.dialogAlert = true;
          this.alertMessage = this.$t('startGrids.save_failure');
      }

      this.startGridDialog = false;
      this.loadStartGrids(this.racesStartSelect.id, true);
    },
    async print() {
      if(this.racesStartSelect) {
        const routeData = this.$router.resolve({name: 'StartGridsPrint', params: { id: this.racesStartSelect.id }});
        window.open(routeData.href, '_blank');
      }
    },
    async download() {
      if(this.racesStartSelect) {
        const response = await this.getApi(`/api/v1/promoter/startGrid/download/${this.racesStartSelect.id}`);
        if(response && !response.success) {
          this.alertMessage = this.$t('startGrids.'+response.message);
          this.dialogAlert = true;
        } else if(!response) {
          this.alertMessage = this.$t('common.general_error');
          this.dialogAlert = true;
        }
      }
    },
    async deleteSG() {
      if(this.racesStartSelect) {
        const response = await this.deleteApi(`/api/v1/promoter/startGrid/deleteStartGrid/${this.racesStartSelect.id}`);
        if(!response || !response.success) {
          this.dialogAlert = true;
          this.alertMessage = this.$t('startGrids.save_failure');
        }

        this.loadStartGrids();
        this.racesStartSelect = null;
        this.showCardGrid = false;
      }
    },
    async generateStartGrid() {
      if(this.racesStartSelect) {
        const startGridId = this.racesStartSelect.id;
        const eventId = this.$route.params.id;
        const response = await this.getApi(`/api/v1/promoter/startGrid/generate/${startGridId}/${eventId}`);
        
        if(!response || !response.success) {
          this.dialogAlert = true;
          if(!response || !response.message) {
            this.alertMessage = this.$t('startGrids.save_failure');
          } else {
            this.alertMessage = this.$t('startGrids.' + response.message);
          }
        }
      }
    },
    confirmDeleteForClass(data) {
      this.dialogNotification = true;
      this.bandForClass = true;
      this.refName = data.refName;
    },
    closeDialogDelete() {
      this.dialogNotification = false;
    }
  },
  computed: {
    headersRace() {
      return [
        {
          text: this.$t("startGrids.race_id"),
          align: "start",
          sortable: false,
          value: "raceId",
        },
        { text: this.$t("startGrids.race_name"), value: "raceName" },
      ];
    },
    headersClass() {
      return [
        {
          text: this.$t("startGrids.class_name"),
          align: "start",
          sortable: false,
          value: "className",
        },
        { text: this.$t("startGrids.total_participants"), value: "totalParticipants" },
        { text: this.$t("startGrids.max_per_row"), value: "maxPerRow" },
        { text: this.$t("startGrids.max_per_class"), value: "maxPerRace" },
        {
          text: this.$t("startGrids.delete"),
          value: "actions",
          sortable: false,
        },
      ];
    },
    headersMiniClass() {
      return [
        {
          text: this.$t("startGrids.class_name"),
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: this.$t("startGrids.total_participants"),
          value: "totalParticipants",
        },
      ];
    },
    headersParticipants() {
      return [
        {
          text: this.$t("startGrids.start_row"),
          align: "start",
          sortable: false,
          value: "startRow",
        },
        {
          text: this.$t("startGrids.position"),
          value: "position",
        },
        {
          text: this.$t("startGrids.race_number"),
          value: "raceNumber",
        },
        {
          text: this.$t("startGrids.first_name"),
          value: "firstName",
        },
        {
          text: this.$t("startGrids.last_name"),
          value: "lastName",
        },
        {
          text: this.$t("startGrids.brand"),
          value: "brand",
        },
        {
          text: this.$t("startGrids.edit_delete"),
          value: "actions",
          sortable: false,
        },
      ];
    },
    startGridNameTitle() {
      if(this.racesStartSelect) {
        return this.racesStartSelect.name;
      }
      return "";
    },
    headerRacesSG() {
      return [
        { text: this.$t('startGrids.race_id'), value: "id" },
        { text: this.$t('startGrids.race_name'), value: "raceName" },
        { text: this.$t('startGrids.from_position'), value: "fromPosition" },
        { text: this.$t('startGrids.top_position'), value: "topPosition" },
        { text: this.$t('startGrids.start_position'), value: "StartPosition" },
        { text: this.$t("startGrids.edit_delete"), value: "actions", sortable: false }
      ];
    },
    racesStartGridTitle() {
      if(this.editItemRacesSG == true) {
        return this.$t("startGrids.edit_races_btn");
      }
      return this.$t("startGrids.add_races_btn");
    },
    startGridTitle() {
      if(this.editStartGrid) {
          return this.$t("startGrids.dialog_edit_title");
      }
      return this.$t("startGrids.dialog_create_title");
    }
  },
  mounted() {
    this.loadRaces();
    this.loadStartGrids();
  },
  watch: {
    addRacesModal(val) {
      if(!val) {
        const parent = this;
        setTimeout(function() {
          parent.editItemRacesSG = false;
        }, 1000);
      }
    },
    startGridDialog(val) {
      if(!val) {
        const parent = this;
        setTimeout(function() {
          parent.editStartGrid = false;
        }, 1000);
      }
    }
  }
};
</script>

<style>
.btn {
  height: 50px !important;
}
</style>
